import { render, staticRenderFns } from "./AdditionIframe.vue?vue&type=template&id=1ad10f46&"
import script from "./AdditionIframe.vue?vue&type=script&lang=ts&"
export * from "./AdditionIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports